import React from 'react';
import ViewLanguageComponent from '../../../Components/Language/ViewLanguage';

export default function ViewLanguage() {
    return (
        <div className='page-body'>
            <ViewLanguageComponent />
        </div>
    );
}